import { LayoutDashboard } from "lucide-react";
import type { ModuleSpec } from "../types";

export const homeSpec: ModuleSpec = {
  id: "home",
  icon: LayoutDashboard,
  i18n: {
    namespace: "modules",
    titleKey: "home.title",
    descriptionKey: "home.description",
  },
  nav: {
    path: "/",
    group: "overview",
    order: 1,
  },
  meta: {
    status: "active",
    description: "Main dashboard and overview",
  },
};
